import { api } from './api';

export interface Marca {
  id: number;
  nome: string;
  ativo: 'SIM' | 'NAO';
}

export interface MarcaRequest {
  id?: number;
  nome: string;
  ativo: 'SIM' | 'NAO';
}

export const marcaService = {
  // Buscar todas as marcas
  getAll: async (): Promise<Marca[]> => {
    const response = await api.get<Marca[]>('/api/Marca/GetAll');
    return response.data;
  },

  // Buscar marca por ID
  getById: async (id: number): Promise<Marca> => {
    const response = await api.get<Marca>(`/api/Marca/GetById?id=${id}`);
    return response.data;
  },

  // Salvar nova marca
  save: async (marca: MarcaRequest): Promise<Marca> => {
    const response = await api.post<Marca>('/api/Marca/Salvar', marca);
    return response.data;
  },

  // Alterar marca existente
  update: async (marca: MarcaRequest): Promise<Marca> => {
    const response = await api.post<Marca>('/api/Marca/Alterar', marca);
    return response.data;
  },
};
